// src/components/IDEConsole/IDEConsoleConfigEditor.tsx
import React, { useState } from 'react';
import { Button, Modal, message } from 'antd';
import JsonEditor from '../JsonEditor/JsonEditor';
import { IDEConsoleConfig } from './types';

export interface IDEConsoleConfigEditorProps {
  currentConfig: IDEConsoleConfig;
  onConfigChange: (config: IDEConsoleConfig) => void;
  title?: string;
  // 👉 Add storageKey for JsonEditor persistence (following IDEPhaser pattern)
  storageKey?: string;
  initialStatement?: string;
  onStatementChange?: (statement: string) => void;
}

const IDEConsoleConfigEditor: React.FC<IDEConsoleConfigEditorProps> = ({
  currentConfig,
  onConfigChange,
  title = 'IDEConsole Configuration',
  storageKey,
  initialStatement,
  onStatementChange
}) => {
  const [importGeneralOpen, setImportGeneralOpen] = useState(false);
  const [importGeneralText, setImportGeneralText] = useState('');

  const handlePreviewGeneral = () => {
    try {
      const parsed = JSON.parse(importGeneralText || '{}');
      onConfigChange(parsed);
      message.success('Prévisualisation appliquée');
    } catch (err) {
      message.error('JSON invalide');
    }
  };

  return (
    <>
      <Button 
        style={{ marginLeft: '8px' }} 
        onClick={() => setImportGeneralOpen(true)}
      >
        Importer config générale
      </Button>

      {/* Import Configuration Modal */}
      <Modal
        title={`${title} - Importer une configuration générale`}
        open={importGeneralOpen}
        onCancel={() => setImportGeneralOpen(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <JsonEditor
          title="Configuration générale"
          value={currentConfig}
          onChangeText={setImportGeneralText}
          showStatement={true}
          initialStatement={initialStatement}
          onStatementChange={onStatementChange}
          onApply={(data) => {
            onConfigChange(data);
            setImportGeneralOpen(false);
            message.success('Configuration importée');
          }}
          extraActions={<Button onClick={handlePreviewGeneral}>Prévisualiser</Button>}
          // 👉 Use storageKey for persistence (following IDEPhaser pattern)
          storageKey={storageKey}
        />
      </Modal>
    </>
  );
};

export default IDEConsoleConfigEditor;
